import { useContext } from 'react'
import { AccordionBodyProps } from './interface'
import { accordionItemContext } from './AccordionItem'

export const AccordionBody = ({ children }: AccordionBodyProps) => {
	const { visible } = useContext(accordionItemContext)
	return <div className={` max-h-0 overflow-hidden ${visible && ' max-h-fit p-4'}`}>{children}</div>
}
